import React from 'react';
import Banner from '../components/banner';
import LoanCalculator from '../components/loan-calculator';
import LoanFeatures from '../components/LoanFeatures';
import LoanStep from '../components/loan-step';
import EligibilityCriteria from '../components/EligibilityCriteria';
import LoanTips from '../components/LoanTips';
import PlatformEcosystem from '../components/PlatformEcosystem';
import PerformanceMetricsStrip from '../components/PerformanceMetricsStrip';
import OurBrands from '../components/our-brands';
import NbfcPartner from '../components/nbfc-partner';
// import HowItWorks from '../components/how-it-works';
import TechnologyCompliance from '../components/technology-compliance';
import OurServices from '../components/our-services';
import WhyChooseUs from '../components/WhyChooseUs';

const Home = () => {
  return (
    <>
      <Banner />
      <PlatformEcosystem />
      {/* <LoanCalculator /> */}
      <LoanFeatures />     
       {/* <HowItWorks /> */}
      <PerformanceMetricsStrip />
      <TechnologyCompliance />
      <OurServices />
      <WhyChooseUs />
      {/* <LoanStep /> */}
      {/* <EligibilityCriteria /> */}
      {/* <LoanTips /> */}
      <NbfcPartner />
      <OurBrands />
    </>
  );
};

export default Home;
